export type TrackingConsent = { analytics: boolean; advertisement: boolean }
export type TrackingConfig = { enabled: boolean; gtmId: string; gaId: string }
export type TrackingMode = 'none' | 'analytics' | 'container'

export function resolveTrackingConfig(input: {
  environment?: string
  enabled?: string
  gtmId?: string
  gaId?: string
}): TrackingConfig {
  return {
    // An explicit switch overrides the production default. Invalid values fail closed.
    enabled:
      input.enabled === undefined ? input.environment === 'production' : input.enabled === 'true',
    gtmId: input.gtmId === undefined ? 'GTM-MN626TL3' : input.gtmId.trim(),
    gaId: input.gaId === undefined ? 'G-TYGZHBVXKY' : input.gaId.trim(),
  }
}

export function consentToGoogle(consent: TrackingConsent) {
  return {
    analytics_storage: consent.analytics ? 'granted' : 'denied',
    ad_storage: consent.advertisement ? 'granted' : 'denied',
    ad_user_data: consent.advertisement ? 'granted' : 'denied',
    ad_personalization: consent.advertisement ? 'granted' : 'denied',
  } as const
}

export function trackingMode(config: TrackingConfig, consent: TrackingConsent): TrackingMode {
  if (!config.enabled || !consent.analytics) return 'none'
  // This mixed container fires GA4, Facebook and TikTok on startup. Both permissions are required.
  if (consent.advertisement) return /^GTM-[A-Z0-9]+$/.test(config.gtmId) ? 'container' : 'none'
  return /^G-[A-Z0-9]+$/.test(config.gaId) ? 'analytics' : 'none'
}
